<template>
	<ClientOnly>
		<div v-if="bankartHold == 1" class="form-loading form-loading-bankart"><BaseCmsLabel code="bankart_hold_loader" tag="span" /></div>
		<template #fallback>
			<BaseThemeUiLoading />
		</template>
	</ClientOnly>
</template>

<script setup>
	const apiRoutes = useApiRoutes();
	const webshop = useWebshop();
	const endpoints = useEndpoints();
	const labels = useLabels();
	const { bankartHold, orderSuccess, paymentError } = useCheckout();

	let urlAddPayment = false;

	let intervalCallOrderStatus;
	onMounted(() => {
		const url = window.location.href;
		const searchParams = new URL(url).searchParams;
		bankartHold.value = 1;
		if (url.includes("|webshopadditionalpayment")) {
			urlAddPayment = true;
		}

		const orderIdentificator = searchParams.get('order_identificator');
		const urlId = orderIdentificator?.replace("|", '-').replace("|webshoporder", '').replace("|webshopadditionalpayment", '').replace("|webshop", '');

		const webshopOrderId = (urlAddPayment) ? endpoints.get('_get_hapi_webshop_additionalpayment_status') : endpoints.get('_get_hapi_webshop_order_status');
		const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", urlId)

		async function callOrderStatus() {
			if(!orderIdentificator){
				clearInterval(intervalCallOrderStatus);
				await navigateTo('/');
				return;
			}

			await useApi(webshopOrder, {method: 'GET'})
			.then(async (res) => {
				if(res.success) {
					clearInterval(intervalCallOrderStatus);
					orderSuccess.value == 0;
					paymentError.value = null;
					if(urlAddPayment) {
						const navigationResult = await navigateTo({path: apiRoutes.getAppUrl('webshop_additionalpayments_thank_you'), query: {order_identificator: urlId}});
						if(!navigationResult) {
							bankartHold.value = 0;
						}
					} else {
						const navigationResult = await navigateTo({path: apiRoutes.getAppUrl('webshop_thank_you'), query: {order_identificator: urlId}});
						if(!navigationResult) {
							bankartHold.value = 0;
						}
					}
				} else if(res.success == false && res.data.next_view != null) {
					clearInterval(intervalCallOrderStatus);
					orderSuccess.value == 0;
					paymentError.value = res.data || null;
					if(urlAddPayment) {
						const navigationResult = await navigateTo({path: apiRoutes.getAppUrl('webshop_payment_new'), query: {order_identificator: urlId, webshopadditionalpayment: '1'}});
						if(!navigationResult) {
							bankartHold.value = 0;
						}
					} else {
						const navigationResult = await navigateTo({path: apiRoutes.getAppUrl('webshop_payment_new'), query: {order_identificator: urlId}});
						if(!navigationResult) {
							bankartHold.value = 0;
						}
					}
				}
			})
		}

		intervalCallOrderStatus = setInterval(callOrderStatus, 2000);
	});

	onBeforeUnmount(() => {
		clearInterval(intervalCallOrderStatus);
	});
</script>

<style lang="less" scoped>
	.form-loading-bankart{
		display: block!important;
		span{width: 400px; margin-left: -200px; font-size: 16px;}

		@media (max-width: @m){
			span{width: 300px; margin-left: -150px; font-size: 14px;}
		}
	}
</style>
